import React from "react";
import { Modal } from "../modal/Modal";
import { FormattedMessage } from "react-intl";
import style from "./StorageLimitModal.scss";
import configs from "../../utils/configs";
import { CloseButton } from "../input/CloseButton";
import PropTypes from "prop-types";
import { Button } from "@fluentui/react-components";

export function StorageLimitModal({ onClose }) {
  const destinationUrl = configs.UPGRADE_URL;

  return (
    <Modal
      title={<FormattedMessage id="storage-limit-modal.title" defaultMessage="Storage Limit Reached" />}
      afterTitle={<CloseButton onClick={onClose} />}
      actions={
        <>
          <Button appearance="outline" onClick={onClose}>
            <FormattedMessage id="storage-limit-modal.close-button" defaultMessage="I understand" />
          </Button>
          <Button appearance="primary" as="a" href={destinationUrl} target="_blank">
            <FormattedMessage id="storage-limit-modal.upgrade-button" defaultMessage="Upgrade now" />
          </Button>
        </>
      }
    >
      <div>
        <p className={style.message}>
          <FormattedMessage
            id="storage-limit-modal.message"
            defaultMessage="You’ve reached your storage limit. Upgrade now to enjoy more space and uninterrupted access to your files."
          />
        </p>
      </div>
    </Modal>
  );
}

StorageLimitModal.propTypes = {
  onClose: PropTypes.func,
  destinationUrl: PropTypes.string
};
